<template>
    <v-card>
        <v-card-title>
            Issue Resources
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-4">
            <v-form ref="resourcesForm" class="fill-height" :lazy-validation="true" v-model="resourcesFormValid">
            <v-row>
                <v-col cols="12" md="4">
                    <h2 style="display: inline-block;">Categories</h2>
                    <template v-if="duplicateCategories && duplicateCategories.length">
                        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                            <template v-slot:activator="{ on }">
                                <v-icon class="duplicate-error" color="#ff5252" v-on="on">mdi-alert</v-icon>
                            </template>
                            <span>{{ `Duplicates: ${duplicateCategories}` }}</span>
                        </v-tooltip>
                    </template>

                    <div class="mt-3 resource-container" :class="{'duplicate-error': duplicateCategories && duplicateCategories.length}">
                        <textarea v-model="categories" />
                    </div>
                </v-col>

                <v-col cols="12" md="4">
                    <h2 style="display: inline-block;">Causes</h2>
                    <template v-if="duplicateCauses && duplicateCauses.length">
                        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                            <template v-slot:activator="{ on }">
                                <v-icon class="duplicate-error" color="#ff5252" v-on="on">mdi-alert</v-icon>
                            </template>
                            <span>{{ `Duplicates: ${duplicateCauses}` }}</span>
                        </v-tooltip>
                    </template>

                    <div class="mt-3 resource-container" :class="{'duplicate-error': duplicateCauses && duplicateCauses.length}">
                        <textarea v-model="causes" />
                    </div>
                </v-col>

                <v-col cols="12" md="4">
                    <h2 style="display: inline-block;">Services</h2>
                    <template v-if="duplicateServices && duplicateServices.length">
                        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                            <template v-slot:activator="{ on }">
                                <v-icon class="duplicate-error" color="#ff5252" v-on="on">mdi-alert</v-icon>
                            </template>
                            <span>{{ `Duplicates: ${duplicateServices}` }}</span>
                        </v-tooltip>
                    </template>

                    <div class="mt-3 resource-container" :class="{'duplicate-error': duplicateServices && duplicateServices.length}">
                        <textarea v-model="services" />
                    </div>
                </v-col>
            </v-row>
            </v-form>
            
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="saveClick" :disabled="lockSave">Save</v-btn>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
export default {
    name: 'IssuesResources',
    props: [],
    components: {
    },
    data: () => ({
        lockSave: false,
        resourcesFormValid: false,
        categories: '',
        causes: '',
        services: ''
    }),

    computed: {
        duplicateCategories() {
            return this.categories.split('\n').filter((e, i, a) => a.indexOf(e) !== i);
        },

        duplicateCauses() {
            return this.causes.split('\n').filter((e, i, a) => a.indexOf(e) !== i);
        },

        duplicateServices() {
            return this.services.split('\n').filter((e, i, a) => a.indexOf(e) !== i);
        }
    },

    methods: {
        getResources: function() {
            let route = (TELSA.apiHost + "issues/resources");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.categories = result.categories.join('\n');
                this.causes = result.causes.join('\n');
                this.services = result.services.join('\n');
                TELSA.loading(false);
            });
        },

        saveClick: function() {
            if(this.duplicateCategories.length || this.duplicateCauses.length || this.duplicateServices.length) {
                return;
            }
            
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: `Are you sure you want to commit your changes to the issues resource lists?`,
                type: '',
                hideCancel: false,
                confirmAction: () => {this.save();}
            });
        },

        save: function() {
            let categoryArray = this.categories.split('\n');
            categoryArray = categoryArray.filter(c => {
                return !!c;
            });
            let causeArray = this.causes.split('\n');
            causeArray = causeArray.filter(c => {
                return !!c;
            });
            let serviceArray = this.services.split('\n');
            serviceArray = serviceArray.filter(c => {
                return !!c;
            });

            let route = (TELSA.apiHost + "issues/resources/edit");
            TELSA.loading(true);
            this.$http.post(route, {args: {categories: categoryArray, causes: causeArray, services: serviceArray}}).then(response => {
                let result = response.body;
                this.$emit('ok');
            });
        }
    },

    mounted() {
        let lockName = `issues_resources`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getResources().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Issue Resources are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot edit them at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
                TELSA.loading(false);
            });
        });
    }


};
</script>

<style scoped>

    .resource-container {
        height: 350px;
        border: #CBCBCB 1px solid;
        border-radius: 5px;
        width: 100%;
        padding: 5px;
        /* box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.75); */
    }
    .resource-container.duplicate-error {
        border: #ff5252 1px solid;
    }
    .resource-container textarea {
        outline: none;
        width: 100%;
        height: 100%;
        resize: none;
        color: #ffffff;
    }

    .duplicate-error {
        display: inline-block;
        vertical-align: text-bottom;
        margin-left: 0.25em;
    }

</style>
